import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { DailyDosingService } from '../../../../services/daily-dosing.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DynamicFormRuleApplierService } from '../../../../services/dynamic-form-builder-rule-applier.service';
import { ColumnMeta } from '../../../../models/dosing.model';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { AddEditDailyDosingComponent } from '../add-edit-daily-dosing/add-edit-daily-dosing.component';

@Component({
  selector: 'app-scratch-pad',
  imports: [DragDropModule, MatTableModule, MatFormFieldModule,
    CommonModule, MatDialogModule, MatIconModule, MatButtonModule,
    MatMenuModule,DragDropModule],
  templateUrl: './scratch-pad.component.html',
  styleUrl: './scratch-pad.component.scss'
})
export class ScratchPadComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  showTable: boolean = false;
  ruleInput: any;
  columns: ColumnMeta[] = [];
  canSave: boolean = false;
  displayedColumns: string[] = [];         // keys for mat-table
  dataSource = new MatTableDataSource<any>;
  @ViewChild(MatSort) sort!: MatSort;
  weightedAverage: number | null = null;
  onflyGridData: any[] = [];

  constructor(private _dialogRef: MatDialogRef<ScratchPadComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _dailyDosingService: DailyDosingService,
    private _ruleApplier: DynamicFormRuleApplierService,
    private _dialog: MatDialog,
    private _cdr: ChangeDetectorRef
  ) {
    this.canSave = _data.canSave;
  }

  ngOnInit(): void {
    this.showTable = false;

    //Rule conition
    let ruleContion = { "SiteID": this._data.SiteID }

    //Evaluate Rule
    var columnsMetaAferRule = this._ruleApplier.applyRulesForRecords(this._data.uiSchema, ruleContion);

    //Remove the hiiden fields
    var removedHiddenColumns = columnsMetaAferRule
      .filter((x) => x.type !== 'hidden')
      .filter((c, i, arr) => arr.findIndex(x => x.key === c.key) === i);

    //Assign the columns
    this.columns = [...removedHiddenColumns];

    //Assign Display Columns
    this.displayedColumns = ['actions', ...removedHiddenColumns.map(c => c.key)];

    //Assign Data
    this.dataSource.data = [...this._data.apiResponse]

    //Apply sort
    this.dataSource.sort = this.sort;

    this.showTable = true;

    if(this._data.apiResponse)
     this.weightedAverage = this._data.apiResponse[0].WeightedAverage;
  }

  openAddForm() {
    const siteId = this._data.SiteID;
    const tankId = this._data.TankId;

    if (!siteId || !tankId) {
      return;
    }
    var inputData = {
      columns: this._data.uiSchema,
      apiResponse: {
        ID: 0,
        SiteID: siteId,
        TankId: tankId,
        TankName: this._data.TankName
      },
      gridData: this.dataSource.data ?? [],
      siteID: this._data.SiteID,
      mode: 'scratch-pad-add',
      canSave: this.canSave
    }

    const dialogRef = this._dialog.open(AddEditDailyDosingComponent, {
      data: inputData,
      disableClose: true

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result);
        this.dataSource.data = [...result];
        this.weightedAverage = result[0].WeightedAverage;
      }
    });
  }

  openEditForm(row: any) {
    this._dailyDosingService.getDailyDosingById(row.ID).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response: boolean) => {
        var inputData = {
          columns: this._data.uiSchema,
          apiResponse: response,
          siteID: this._data.SiteID,
          gridData: this.dataSource.data ?? [],
          mode: 'scratch-pad-edit'
        }

        const dialogRef = this._dialog.open(AddEditDailyDosingComponent, {
          data: inputData,
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
             console.log(result);
            this.dataSource.data = [...result];
            this.weightedAverage = result[0].WeightedAverage;
          }
        });
      }
    });
  }

  onCancel(): void {
    this._dialogRef.close(false);
  }
}
